import { FunctionComponent, PropsWithChildren } from 'react';
import { Accordion } from 'react-bootstrap';
import { CustomAccordionBodyProps, CustomAccordionProps } from './types';

// eslint-disable-next-line
export const CustomAccordion: FunctionComponent<CustomAccordionProps> = (props: PropsWithChildren<CustomAccordionProps>) => {
    const {
        id,
        containerClassName,
        children,
        nameRHS,
        nameRHSClassName,
    } = props;

    return (
        <div id={id} className={`${containerClassName ?? ''}`}>
            <Accordion
                defaultActiveKey='0'
                bsPrefix='wizard-accordion'
            >
                {children}
            </Accordion>
        </div>
    );
};

// eslint-disable-next-line
export const CustomAccordionBody: FunctionComponent<CustomAccordionBodyProps> = (props: PropsWithChildren<CustomAccordionBodyProps>) => {
    const {
        id,
        name,
        namePartTwo,
        namePartTwoClassName,
        namePartThree,
        namePartThreeClassName,
        nameRHS,
        nameRHSClassName,
        eventKey,
        children,
        className,
    } = props;

    return (
        <Accordion.Item eventKey={eventKey} className='open'>
            <Accordion.Header id={id}>
                <span className='d-block me-3 w-100 lh-lg'>
                    <span className='d-block acd-title'>{name}</span>
                    {namePartTwo
                        ? (
                            <span className={`d-block ${namePartTwoClassName}`}>
                                {namePartTwo}
                            </span>
                        ) : null}
                    {namePartThree
                        ? (
                            <span className={`d-block fw-normal text-truncate pre-wrap ${namePartThreeClassName}`}>
                                {namePartThree}
                            </span>
                        ) : null}
                </span>
                {/* TO DO - for new PA status pill */}
                {nameRHS
                    ? (
                        <span className={`d-block ms-auto me-3 fw-normal ${nameRHSClassName}`}>
                            {nameRHS}
                        </span>
                    ) : null}

            </Accordion.Header>
            <Accordion.Body className={className}>
                {children}
            </Accordion.Body>
        </Accordion.Item>
    );
};
